import React from "react";
import { MatchParams } from "src/routes";
import { AuthStore, UserStore, RoutingStore} from "src/stores";
import { inject, observer } from "mobx-react";
import { SpaceType } from "src/types";
import { Paper } from "src/components";
import { theme } from "src/config";
import { UserInviteForm } from "./views";

export interface IUserInviteProps {
  authStore:    AuthStore;
  userStore:    UserStore;
  routingStore: RoutingStore;
  params:       MatchParams;
}

export const UserInvite = inject("authStore", "routingStore", "userStore")(observer((props: IUserInviteProps): JSX.Element => {
  return (
    <Paper $noShadow style={{...theme.paper.small, ...{marginBottom: "2rem"}}}>
      <UserInviteForm spaceType={props.params.view as SpaceType} space_id={Number(props.params.id)}/>
    </Paper>
  )
}));
